import { ImagesEmpty40, User24 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './ImageNone.css';

type TImageNoneProps = {
  type: 'offer' | 'agent';
};

export const ImageNone: React.VFC<TImageNoneProps> = ({ type }) => (
  <div className={styles['container']}>
    <span className={styles['icon']}>
      {type === 'offer' ? <ImagesEmpty40 color="current_color" /> : <User24 color="current_color" />}
    </span>
  </div>
);
